import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import DataTable from "@/components/layout/DataTable.vue";
import SearchInput from "@/components/layout/SearchInput.vue";
import {computed, ref, watch} from "vue";
import {useI18n} from "vue3-i18n";
import {ActivityRegistration, Participant} from "@/types/entities/activity";
import {Guid} from "@/types";

interface propsInterface {
  participants: Participant[],
  activityRegistration: ActivityRegistration | undefined,
  isLessThanTwoDays: boolean
}

// eslint-disable-next-line no-undef

export default /*#__PURE__*/_defineComponent({
  __name: 'MemberActivityParticipantTable',
  props: {
    participants: {},
    activityRegistration: {},
    isLessThanTwoDays: { type: Boolean }
  },
  emits: ["deleteParticipant"],
  setup(__props: any, { emit: __emit }) {

const {t} = useI18n();

// eslint-disable-next-line
const props = __props;

// eslint-disable-next-line
const emit = __emit;

const participants = ref(props.participants);
const isLessThanTwoDays = ref(props.isLessThanTwoDays);
const activityRegistration = ref(props.activityRegistration);
const participantsSearchValue = ref("")

watch(props, (newProps) => {
  participants.value = newProps.participants;
  isLessThanTwoDays.value = newProps.isLessThanTwoDays;
  activityRegistration.value = newProps.activityRegistration;
});

async function handleDelete(participant: any) {
  if (participant?.id == null || !Guid.isValid(participant.id ?? ""))
    return;

  let confirmDelete = confirm(t("participants.form.deleteConfirmation"));
  if (!confirmDelete)
    return;

  emit("deleteParticipant", participant.id)
}

// DataTable
const participantsHeader = computed(() => {
  let headers = [
    {
      text: t("participants.lastName"),
      value: "lastName",
      sortable: true
    },
    {
      text: t("participants.firstName"),
      value: "firstName",
      sortable: true
    },
    {
      text: t("participants.email"),
      value: "emailAddress",
      sortable: true
    },
    {
      text: t("participants.allergies"),
      value: "allergies",
      sortable: true
    },
    {
      text: t("participants.reducedMobility"),
      value: "reducedMobility",
      sortable: true
    }
  ];

  if (!isLessThanTwoDays.value) {
    headers.push({
      text: t("global.table.actions"),
      value: "actions",
      sortable: false
    })
  }
  return headers;
})

const participantsItems = computed(() => {
  let items: any[] = [];
  if (participants.value != null && participants.value.length > 0) {
    participants.value.forEach((participant: Participant) => {
      items.push({
        ...participant,
        allergies: participant.allergies?.length ? participant.allergies : t('global.undefined'),
        reducedMobility: participant.reducedMobility ? t('global.yes') : t('global.no'),
        actions: {
          delete: !isLessThanTwoDays.value
        },
      });
    });
  }

  return items
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (participantsItems.value.length)
      ? (_openBlock(), _createBlock(SearchInput, {
          key: 0,
          modelValue: participantsSearchValue.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((participantsSearchValue).value = $event)),
          class: "util--ml-auto"
        }, null, 8, ["modelValue"]))
      : _createCommentVNode("", true),
    _createVNode(DataTable, {
      headers: participantsHeader.value,
      items: participantsItems.value,
      "search-value": participantsSearchValue.value,
      onDelete: handleDelete
    }, null, 8, ["headers", "items", "search-value"])
  ], 64))
}
}

})